import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {CurrencyPipe} from '@angular/common';
import {DecimalPipe} from '@angular/common';
import { ChequesTemplatesService } from '../../../services/cheques-templates.service';
import {HelpersService} from "../../../services/tools/helpers.service";
declare var $;
declare var fabric;

@Component({
  selector: 'app-print-cheque-modal',
  templateUrl: './print-cheque-modal.component.html',
  styleUrls: ['./print-cheque-modal.component.scss']
})
export class PrintChequeModalComponent {

  @Input() public selected: any = {};
  @Input() private callback: string;

  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;

  public canvas:any;
  public font_size:number=16;
  public canvasObjects:any=[];
  public fieldPositions:any=[];
  public monto_letra:string="";

  public monto_numero_loaded:boolean=false;
  public loaded_fields:any=[];
  public selected_template:any;
  public new_template:any = undefined;
  public new_template_valid:boolean=true;

  public templates:any=[];

  public loading_create:boolean = false;
  public loading_update:boolean = false;

  public defaultInitialPositions:any=[
    {
      field_name: 'fecha',
      left: 650,
      top: 10,
      width: 150
    },
    {
      field_name: 'monto_numero',
      left: 470,
      top: 110,
      width: 150
    },
    {
      field_name: 'monto_letra',
      left: 50,
      top: 160,
      width: 400
    }
  ];

  constructor(private cp: CurrencyPipe, 
              private dp: DecimalPipe,
              private chequesTemplatesServices: ChequesTemplatesService,
              private helperService: HelpersService) {
  }

  ngAfterViewInit() {
    this.loadTemplates();
  }

  addDestinatarioField() {
    this.defaultInitialPositions.push(
      {
        field_name: 'destinatario',
        left: 50,
        top: 110,
        width: 400
      });

      console.log('initial positions ....', this.defaultInitialPositions);
  }

  isTraspaso() {
    if (!this.selected) {
      return false;
    }

    return (this.selected.conceptos.traspaso == 1);
  }

  loadTemplates(){
    this.chequesTemplatesServices.getTemplates()
      .subscribe(
        response=>{
          this.templates = response.json().content;
          console.log("TEMPLATES RECEIVED FROM SERVER:: "+JSON.stringify(this.templates));
        },
        error=>{
          this.helperService.httpGlobalError(error);

          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
          //alert("ERROR:: "+ JSON.stringify(error));
        }
      );
    this.selected_template = undefined;
    this.new_template = undefined;
    this.loaded_fields=[];
    this.canvasObjects=[];
  }

  loadTemplate(template){

    this.selected_template = template;
    this.setupCanvas(true);
    this.setupFieldsInitialPositions(this.selected_template);
  }

  setupCanvas(injectFields){
    var parent = this;
    setTimeout(function(){
        parent.canvas = new fabric.Canvas('c');
        fabric.Object.prototype.transparentCorners = false;
        if(injectFields){
          for(var i=0;i<parent.fieldPositions.length;i++){
            var fp = parent.fieldPositions[i];
            if(fp.field_name=='fecha'){
              parent.addField(fp.field_name, parent.isoToMX(parent.selected.fechaMovimiento));
            }else if(fp.field_name=='destinatario' && !parent.isTraspaso()){
              parent.addField(fp.field_name, parent.selected.proveedores.nombre);
            }else if(fp.field_name=='monto_numero'){
              parent.addField(fp.field_name, parent.selected.importeLabel+'');
            }else if(fp.field_name=='monto_letra'){
              parent.addField(fp.field_name, parent.selected.importeLetras+'');
            }
          }
        }
    },600);
  }
  isoToMX(dateString){
    const year = dateString.slice(0,4);
    const month = dateString.slice(5,7);
    const day = dateString.slice(8,10);
    
    return  day+'/'+month+'/'+year;

  }

  setupFieldsInitialPositions(template_data){
    //En template_data vendrá un nombre y una serie de posiciones pero en un JSON como string dentro
    //de "contenido_json", asi que debemos parsearlo
    var field_positions = JSON.parse(template_data.contenido_json);
    console.log('template_data ', template_data);
    this.fieldPositions = field_positions || {};
  }

  showTemplateCreation(){
    this.new_template_valid=true;
    this.new_template="";
  }

  createNewTemplate(){
    if(this.new_template===""){
      this.new_template_valid=false;
      return;
    }
    var data={
      nombre: this.new_template
    };
    this.loading_create = true;
    this.chequesTemplatesServices.createTemplate(data)
      .subscribe(
        response=>{
          this.loading_create = false;
          this.setupCanvas(false);
          if (!this.isTraspaso()) {
            this.addDestinatarioField();
          }
          this.selected_template = 
            {
              id: response.json().content.id,
              nombre: this.new_template,
              contenido_json: this.escapeJSON(this.defaultInitialPositions)
            };
          this.setupFieldsInitialPositions(this.selected_template);
        },
        error=>{
          this.loading_create = false;
          this.helperService.httpGlobalError(error);

          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
          //alert("ERROR:: "+JSON.stringify(error));
        }
      );

  }

  deleteTemplate(template){
    if(confirm("¿Esta seguro que desea borrar el template '"+template.nombre+"'?")){

      template.loading_delete = true;
      this.chequesTemplatesServices.deleteTemplate(template.id)
        .subscribe(
          response=>{
            template.loading_delete = false;
            this.loadTemplates();
          },
          error=>{
            template.loading_delete = false;
            this.helperService.httpGlobalError(error);

            if (error == 400) {
              console.log('getFechasActual - error 400 ' , error);
            }
            //alert("ERROR:: "+JSON.stringify(error));
          }
        );
    }

  }

  saveTemplate(){
    //Iteramos el arreglo de control
    var templateInfo = [];
    for(var i=0; i<this.canvasObjects.length; i++){
      var co = this.canvasObjects[i];
      var field_name = co.field_name;
      var canvas_item = this.canvas.item(co.canvas_object_index);
      if (canvas_item) {
        templateInfo.push(
          {
            field_name: field_name,
            left: canvas_item.left,
            top: canvas_item.top,
            width: canvas_item.width,
          }
        );
      }
    }

    //TODO: Hacer put del template
    var template_json={
      id: this.selected_template.id,
      nombre: this.selected_template.nombre,
      contenido_json: this.escapeJSON(templateInfo)
    };
    this.loading_update = true;
    this.chequesTemplatesServices.updateTemplate(template_json, this.selected_template.id)
      .subscribe(
        response=>{
          this.loading_update = false;
        },
        error=>{
          this.loading_update = false;

          this.helperService.httpGlobalError(error);

          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
          //alert("ERROR:: "+JSON.stringify(error));
        }
      );
    
  }

  findCanvasObject(field_name){
    console.log("Searching field name:: "+field_name);
    for(var i=0;i<this.canvasObjects.length;i++){
      var co = this.canvasObjects[i];
      if(co.field_name==field_name){
        console.log("Field name found, returning index:: "+co.canvas_object_index);
        return co.canvas_object_index;
      }
    }
    console.log("Field name "+field_name+" not found");
    return -1;
  }

  addCanvasObject(field_name, co){
    console.log("Adding field "+field_name+" with index: "+this.canvasObjects.length);
    this.canvas.add(co);
    this.canvasObjects.push(
      {
        field_name: field_name,
        canvas_object_index: this.canvasObjects.length
      }
    );
    this.loaded_fields.push(field_name);
  }

  retrieveFieldPositionData(field_name){
    for(var i=0;i<this.fieldPositions.length;i++){
      var fp = this.fieldPositions[i];
      if(fp.field_name == field_name){
        return fp;
      }
    }
    
    if (field_name) {
      const defaultPosition = this.getFieldDefaultPosition(field_name);
      console.log('defaultPosition ', defaultPosition);
      return defaultPosition;
    } 

    return false;
  }

  getFieldDefaultPosition(field_name) {
    if (!this.isTraspaso()) {
      this.addDestinatarioField();
    }

    const defaultPositions = this.defaultInitialPositions;

    return defaultPositions.find(item => { return item.field_name == field_name });
  }


  addField(field_name, field_value){
    console.log('field_name ', field_name);
    console.log('field_value ', field_value);
    if(field_value==="") return;
    var field_position = this.retrieveFieldPositionData(field_name);
    console.log('field_position ', field_position);
    if(!field_position) return;

    var canvas_object_index = this.findCanvasObject(field_name);
    console.log('canvas found ', canvas_object_index);
    if(canvas_object_index==-1){

      /*
      if(field_name=='monto_numero'){
        field_value = this.dp.transform(field_value, '1.0-0')
      }*/
      var fontSizeToUse = 16;
      if(field_value.length>35){
        fontSizeToUse = 12;
      }
      var canvas_obj = new fabric.Textbox(field_value, {
        left: field_position.left,
        top: field_position.top,
        width: field_position.width,
        fontSize: fontSizeToUse
      });
      this.addCanvasObject(field_name, canvas_obj);
      this.canvas.setActiveObject(canvas_obj);
    }else{
      this.canvas.setActiveObject(this.canvas.item(canvas_object_index));
    }
    this.canvas.requestRenderAll();

  }

  removeField(field_name){
    console.log("Removing field:: "+field_name);
    var canvas_object_index = this.findCanvasObject(field_name);
    console.log("Index to remove::"+canvas_object_index);
    if(canvas_object_index!=-1){
      if(field_name=='monto_numero'){
        this.monto_numero_loaded = false;
      }
      //Removemos del arreglo de control
      for(var i=0;i<this.canvasObjects.length;i++){
        var co = this.canvasObjects[i];
        if(co.field_name==field_name){
          this.canvasObjects.splice(i,1);
        }
      }
      //Removemos del arreglo de campos
      for(var i=0;i<this.loaded_fields.length;i++){
        var lf = this.loaded_fields[i];
        if(lf===field_name){
          this.loaded_fields.splice(i,1);
        }
      }
      //Removemos del canvas
      this.canvas.remove(this.canvas.item(canvas_object_index));
      this.canvas.requestRenderAll();
    }
  }
  
  print() {
    this.canvas.discardActiveObject();
    this.canvas.requestRenderAll();
    setTimeout(function(){
      window.print();
    },1000);
  }

  emit() {

    if (this.callback) {
      this.goToCallback.emit(this.callback);
    }
  }

  close() {

    this.emit();
    $('#print-cheque-modal').modal('hide');
  }

  open() {
    console.log('selected cheques ', this.selected);
    this.loadTemplates();
    $('#print-cheque-modal').modal('show');
  }

  escapeJSON(target) {
    target = JSON.stringify(target);
    var escapedJSON = target.replace(/\\n/g, "\\n")
               .replace(/\\'/g, "\\'")
               .replace(/\\"/g, '\\"')
               .replace(/\\&/g, "\\&")
               .replace(/\\r/g, "\\r")
               .replace(/\\t/g, "\\t")
               .replace(/\\b/g, "\\b")
               .replace(/\\f/g, "\\f");
      console.log("ESCAPED JSON:: "+escapedJSON);
      return escapedJSON;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/partials/print-cheque-modal/print-cheque-modal.component.ts